/*
 * @poppinss/prompts
 *
 * (c) Poppinss
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import useColors from '@poppinss/colors'
import { Colors } from '@poppinss/colors/types'

/**
 * Colors and icons to use.
 */
const colors: Colors = useColors.ansi()
export { colors }
